<div class="column-title">Notifications 
    <button class="toggle" mat-icon-button (click)="userSettings.toggle('notificationColumnToggle')">
        <mat-icon>play_arrow</mat-icon>
    </button>
</div>
<div class="inner">
    <div class="notification" *ngFor="let note of notifyService.notifications; let i = index">
        <span class="date">{{note.date | date:'L/d \'at\' h:mma'}}</span> <span class="title" [innerHtml]="linkService.linkify(note.title)"></span>
        <div class="actions">
            <a 
                class="button small" 
                [routerLink]="['/slideshow', note.assignment]" 
                routerLinkActive="active">
                    Go Now
            </a> 
            <button 
                class="button faded" 
                (click)="notifyService.mark('dismissed', i)">
                    Dismiss
            </button>
        </div>
    </div>
</div>